import { useEffect } from 'react';
import decimal from 'decimal.js';
import { TextLine3, ForDevelopment } from './UtilComponents';
import { SelectSessionButton } from './KeysAndSigningUI';
import { useGlobalStateSelector, words } from './globalState';
import {
  handleClickGetPointSum,
  handleClickGetPointHistory,
  handleClickClearPurchase,
  handleClickSignPurchase,
  sendMonaSequence,
} from './monatokaPoint';
import { handleClickGoTop } from './monadomCore';
import { getValidKeyPairs } from './keysAndSigning';
import { localTime, devLog, sendLog } from './utils';
import iconCircleLeft from './arrow_circle_left_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleRight from './arrow_circle_right_FILL0_wght400_GRAD0_opsz48.svg';
import iconSign from './history_edu_FILL0_wght400_GRAD0_opsz48.svg';
import iconSearch from './search_FILL0_wght400_GRAD0_opsz48.svg';
import iconDetail from './more_horiz_FILL0_wght400_GRAD0_opsz48.svg';

// CHARGE POINT
function ChargePoint(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const keyPairsInPoolAll = useGlobalStateSelector( ({ state }) => state.keyPairs );
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  let historyItems;
  let historyFunction;
  let arrowLeft;
  let arrowRight;
  let pointSum;

  useEffect( () => {
    const func = async () => {
      if (state.getPointHistory.addressMain !== undefined && state.getPointHistory.addressMain !== null && state.getPointHistory.addressMain !== '') {
        handleClickGetPointSum(state, dispatch)
        .catch( () => {
          // 何もしない
        });
      }
    }

    func();

    dispatch({ type: 'setState', key: 'purchasePoint',
      value: {
        purchaseNo: null,
        addressMain: state.purchasePoint.addressMain,
        addressPayFrom: state.purchasePoint.addressPayFrom,
        amountToBuy: state.purchasePoint.amountToBuy,
        signatureByAddressMain: '',
        signatureByAddressPayFrom: '',
        disabled: false,
        status: 'waitingForSignature',
      }
    });
  }, []);

  let purchaseNo;

  if (state.purchasePoint.purchaseNo !== undefined && state.purchasePoint.purchaseNo !== null && state.purchasePoint.purchaseNo !== '') {
    purchaseNo = state.purchasePoint.purchaseNo;
  }
  else {
    purchaseNo = '-';
  }

  // ポイント合計

  if (state.pointSum[state.getPointHistory.addressMain]?.pointSum !== undefined) {
    pointSum = <div>
      { state.pointSum[state.getPointHistory.addressMain]?.pointSum }
    </div>;
  }
  else {
    pointSum = <div>
      -
    </div>;
  }

  // アクションごとのhistoryItemsとhistoryFunction設定。

  if (state.getPointHistory.action === 'point') {
    if (state.pointHistory[state.getPointHistory.addressMain]?.point !== undefined) {
      historyItems = state.pointHistory[state.getPointHistory.addressMain].point
      .filter( record => record.purchaseNo !== 0 )
      .map( record => {
        if (true) {
          return <PointRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<PointRecordTitle />);
    }
    else {
      historyItems = [<PointRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      handleClickGetPointHistory(state, dispatch, pagingIndex)
      .catch( () => {
          // 何もしない
      });
    };
  }

  // 矢印

  if ( state.getPointHistory.pagingIndex[state.getPointHistory.action] >= 1 ) {
    arrowLeft = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => historyFunction(state.getPointHistory.pagingIndex[state.getPointHistory.action] - 1) }
      >
        <img className='size2x2' src={iconCircleLeft} alt='left' />
      </button>
    </div>
  }
  else {
    arrowLeft = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  if ( state.getPointHistory.lastEvaluatedKey[state.getPointHistory.action][state.getPointHistory.pagingIndex[state.getPointHistory.action]] !== undefined &&
       state.getPointHistory.lastEvaluatedKey[state.getPointHistory.action][state.getPointHistory.pagingIndex[state.getPointHistory.action]] !== null ) {
    arrowRight = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => { historyFunction(state.getPointHistory.pagingIndex[state.getPointHistory.action] + 1) } }
      >
        <img className='size2x2' src={iconCircleRight} alt='right' />
      </button>
    </div>
  }
  else {
    arrowRight = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  // ポイント購入セクション

  const purchaseSection =
    <div>
      <div className='visibleMiddleOrMore flexColumn alignItemsFlexStart borderKOM marginSide1 padding0p5'>
        <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
          <div>
            { words.purchasePoints[state.language] }
          </div>
          <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
            onClick={ () => {
              handleClickClearPurchase(state, dispatch);
            }}
          >
            {words.clear[state.language]}
          </button>
        </div>
        <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter marginTop1 widthMax'>
            <div>
              { 'No. ' + purchaseNo }
            </div>
          </div>
        </div>
        <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
          <TextLine3 fieldName='purchaseAddressMain' keys={['purchasePoint', 'addressMain']} face={words.addressMain[state.language]} tooltip={true} disabled={state.purchasePoint.disabled} />
          <SelectSessionButton stateKeysToSetAddress={[['purchasePoint', 'addressMain']]} stateKeysToSetUserName={[]} loginEnabled={false} />
          {/* mpurseButton(['purchasePoint', 'addressMain']) */}
        </div>
        <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
          <TextLine3 fieldName='addressPayFrom' keys={['purchasePoint', 'addressPayFrom']} face={words.addressPayFrom[state.language]} tooltip={true} disabled={state.purchasePoint.disabled} />
          <SelectSessionButton stateKeysToSetAddress={[['purchasePoint', 'addressPayFrom']]} stateKeysToSetUserName={[]} loginEnabled={false} />
          {/* mpurseButton(['purchasePoint', 'addressPayFrom']) */}
        </div>
        <TextLine3 fieldName='amountToBuy' keys={['purchasePoint', 'amountToBuy']} face={words.amountToBuy[state.language]} type='setStateMultiLayersNum' disabled={state.purchasePoint.disabled} />
        {
          (state.purchasePoint.signatureByAddressMain === undefined ||
           state.purchasePoint.signatureByAddressMain === null ||
           state.purchasePoint.signatureByAddressMain === '') ?
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
              onClick={ () => {
                const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: keyPairsInPoolAll });
                const keyPair = keyPairsInPool[state.purchasePoint.addressMain]?.keyPair;

                handleClickSignPurchase(state, dispatch, 'addressMain', null, keyPair)
                .catch( () => {
                  // 何もしない
                });
              }}
            >
              <div>
                {words.signByMainAddress[state.language]}
              </div>
              <img className='size2x2' src={iconSign} alt='sign' />
            </button>
          : null
        }
        {
          ( state.purchasePoint.signatureByAddressMain !== undefined &&
            state.purchasePoint.signatureByAddressMain !== null &&
            state.purchasePoint.signatureByAddressMain !== '' &&
           (state.purchasePoint.signatureByAddressPayFrom === undefined ||
            state.purchasePoint.signatureByAddressPayFrom === null ||
            state.purchasePoint.signatureByAddressPayFrom === '')) ?
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
              onClick={ () => {
                const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: keyPairsInPoolAll });
                const keyPair = keyPairsInPool[state.purchasePoint.addressPayFrom]?.keyPair;

                handleClickSignPurchase(state, dispatch, 'addressPayFrom', null, keyPair)
                .catch( () => {
                  // 何もしない
                });
              }}
            >
              <div>
                {words.signByAddressYouPayFrom[state.language]}
              </div>
              <img className='size2x2' src={iconSign} alt='sign' />
            </button>
          : null
        }
      </div>
      <div className='visibleSmallOrLess flexColumn alignItemsFlexStart borderKOM marginTop1 padding0p5'>
        <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
          <div>
            { words.purchasePoints[state.language] }
          </div>
          <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
            onClick={ () => {
              handleClickClearPurchase(state, dispatch)
              .catch( () => {
                // 何もしない
              });
            }}
          >
            {words.clear[state.language]}
          </button>
        </div>
        <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter marginTop1 widthMax'>
            <div>
              { 'No. ' + purchaseNo }
            </div>
          </div>
        </div>
        <div className='flexColumn alignItemsFlexStart marginTop1'>
          <TextLine3 fieldName='purchaseAddressMain' keys={['purchasePoint', 'addressMain']} face={words.addressMain[state.language]} tooltip={true} disabled={state.purchasePoint.disabled} />
          <SelectSessionButton stateKeysToSetAddress={[['purchasePoint', 'addressMain']]} stateKeysToSetUserName={[]} loginEnabled={false} />
          {/* mpurseButton(['purchasePoint', 'addressMain']) */}
        </div>
        <div className='flexColumn alignItemsFlexStart marginTop1'>
          <TextLine3 fieldName='addressPayFrom' keys={['purchasePoint', 'addressPayFrom']} face={words.addressPayFrom[state.language]} tooltip={true} disabled={state.purchasePoint.disabled} />
          <SelectSessionButton stateKeysToSetAddress={[['purchasePoint', 'addressPayFrom']]} stateKeysToSetUserName={[]} loginEnabled={false} />
          {/* mpurseButton(['purchasePoint', 'addressPayFrom']) */}
        </div>
        <TextLine3 fieldName='amountToBuy' keys={['purchasePoint', 'amountToBuy']} face={words.amountToBuy[state.language]} type='setStateMultiLayersNum' disabled={state.purchasePoint.disabled} />
        {
          (state.purchasePoint.signatureByAddressMain === undefined ||
           state.purchasePoint.signatureByAddressMain === null ||
           state.purchasePoint.signatureByAddressMain === '') ?
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
              onClick={ () => {
                const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: keyPairsInPoolAll });
                const keyPair = keyPairsInPool[state.purchasePoint.addressMain]?.keyPair;

                handleClickSignPurchase(state, dispatch, 'addressMain', null, keyPair)
                .catch( () => {
                  // 何もしない
                });
              }}
            >
              <div>
                {words.signByMainAddress[state.language]}
              </div>
              <img className='size2x2' src={iconSign} alt='sign' />
            </button>
          : null
        }
        {
          ( state.purchasePoint.signatureByAddressMain !== undefined &&
            state.purchasePoint.signatureByAddressMain !== null &&
            state.purchasePoint.signatureByAddressMain !== '' &&
           (state.purchasePoint.signatureByAddressPayFrom === undefined ||
            state.purchasePoint.signatureByAddressPayFrom === null ||
            state.purchasePoint.signatureByAddressPayFrom === '')) ?
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
              onClick={ () => {
                const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: keyPairsInPoolAll });
                const keyPair = keyPairsInPool[state.purchasePoint.addressPayFrom]?.keyPair;

                handleClickSignPurchase(state, dispatch, 'addressPayFrom', null, keyPair)
                .catch( () => {
                  // 何もしない
                });
              }}
            >
              <div>
                {words.signByAddressYouPayFrom[state.language]}
              </div>
              <img className='size2x2' src={iconSign} alt='sign' />
            </button>
          : null
        }
      </div>
    </div>;

  // 履歴コントロールセクション

  let controlSection =
    <div>
      <div className='visibleMiddleOrMore flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
        {/* addressMain */}
        <TextLine3 fieldName='historyAddressMain' keys={['getPointHistory', 'addressMain']} face={words.addressMain[state.language]} tooltip={true}
          extraFunctionOnChange={ [
            {
              function: () => {
                dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'pagingIndex'],
                  value: { point: 0 }
                });
                dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'lastEvaluatedKey'],
                  value: { point: [] }
                });
              },
              arguments: [],
            }
          ]}
        />
        <SelectSessionButton stateKeysToSetAddress={[['getPointHistory', 'addressMain']]} stateKeysToSetUserName={[]} loginEnabled={false}
          extraFunction={ () => {
            dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'pagingIndex'],
              value: { point: 0 }
            });
            dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'lastEvaluatedKey'],
              value: { point: [] }
            });
          }}
        />
        {/* mpurseButtonForHistory */}
        <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
          <img className='size2x2' src={iconSearch} alt='search' />
        </button>
        { arrowLeft }
        { arrowRight }
      </div>
      <div className="visibleSmallOrLess flexColumn">
        {/* addressMain */}
        <TextLine3 fieldName='historyAddressMain' keys={['getPointHistory', 'addressMain']} face={words.addressMain[state.language]} tooltip={true}
          extraFunctionOnChange={ [
            {
              function: () => {
                dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'pagingIndex'],
                  value: { point: 0 }
                });
                dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'lastEvaluatedKey'],
                  value: { point: [] }
                });
              },
              arguments: [],
            }
          ]}
        />
        <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax '>
          <div className='flexRow'>
            <SelectSessionButton stateKeysToSetAddress={[['getPointHistory', 'addressMain']]} stateKeysToSetUserName={[]} loginEnabled={false}
              extraFunction={ () => {
                dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'pagingIndex'],
                  value: { point: 0 }
                });
                dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'lastEvaluatedKey'],
                  value: { point: [] }
                });
              }}
            />
            {/* mpurseButtonForHistory */}
            <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
              <img className='size2x2' src={iconSearch} alt='search' />
            </button>
          </div>
          <div className='flexRow'>
            <div className='marginSide0p5'>
              { arrowLeft }
            </div>
            <div className='marginSide0p5'>
              { arrowRight }
            </div>
          </div>
        </div>
      </div>
    </div>;

  // ポイント合計検索ボタン

  const pointSumButton =
  <button className='button1' tabindex='0'
    onClick={ async () => {
      handleClickGetPointSum(state, dispatch)
      .catch( () => {
        // 何もしない
      });

      // if (result?.message === 'nfcRequired') {
      //   const callback = (keyPairs) => {
      //     handleClickGetPointSum(state, dispatch, null, null, keyPairs);
      //     keepKeyPairsInMemory(state, dispatch, keyPairs);
      //   };

      //   handleClickNfc(state, dispatch, callback);
      // }
      // else if (result?.message === 'bcRequired') {
      //   const callback = (keyPairs) => {
      //     handleClickGetPointSum(state, dispatch, null, null, keyPairs);
      //     keepKeyPairsInMemory(state, dispatch, keyPairs);
      //   };

      //   handleClickScanQr(state, dispatch, callback);
      // }
    }}
  >
    <img className='size2x2' src={iconSearch} alt='' />
  </button>;

  const headerFixed =
  <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
    <div className='flexRow justifyContentFlexEnd marginBottom1' >
      <button className='button2' onClick={ () => handleClickGoTop(state, dispatch, navigate) }>
        { words.back[state.language] }
      </button>
    </div>
  </div>;

  const headerRelative =
  <div className='widthMax height6 ' >
  </div>;


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className='flexColumn'>
          { headerRelative }
          <div className='flexRow justifyContentCenter'>
            <div className='flexRow alignItemsFlexEnd marginSide1'>
              <div className='flexColumn justifyContentCenter alignItemsCenter boxMonatokaPoint '>
                <div className='font2'>
                  { pointSum }
                </div>
                <div className=''>
                  { 'point' }
                </div>
              </div>
              { pointSumButton }
            </div>
            { purchaseSection }
            <div className='flexColumn alignItemsFlexStart width50 preWrap borderKOM marginSide1 padding0p5'>
              { state.config.clientParameters.monatokaPointDescription }
            </div>
          </div>
          {/* history */}
          { controlSection }
          { historyItems }
          {/* development */}
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn">
        { headerRelative }
        <div className='flexRow justifyContentCenter alignItemsCenter widthMax marginTopBottom1'>
          <div className='flexColumn justifyContentCenter alignItemsCenter marginRight1'>
            <div className='font2'>
              { pointSum }
            </div>
            <div className=''>
              { 'point' }
            </div>
          </div>
          { pointSumButton }
        </div>
        { purchaseSection }
        <div className='flexColumn alignItemsFlexStart widthMax preWrap borderKOM marginTopBottom1 padding0p5'>
          { state.config.clientParameters.monatokaPointDescription }
        </div>
        {/* history */}
        { controlSection }
        { historyItems }
      </div>
      { headerFixed }
    </div>
  );
}

// POINT RECORD TITLE
function PointRecordTitle() {
  const state = useGlobalStateSelector(({ state }) => state);

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { words.purchaseNo[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.amountFree[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.amountToBuy[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.expirationTime[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.status[state.language] }
          </div>
          <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite' disabled={true} />
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// POINT RECORD
function PointRecord(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const record = props.record;

  const popup = { type: 'pointRecordDetail', body: record };

  const buttons =
  <button className='button1' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup }) } } >
    <img className='size2x2' src={iconDetail} alt='detail' />
  </button>;


  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { 'No. ' + record.purchaseNo }
          </div>
          <div className='marginSide1 widthMin15' >
            { record.amountFree }
          </div>
          <div className='marginSide1 widthMin15' >
            { record.amountToBuy }
          </div>
          <div className='marginSide1 widthMin15' >
            { localTime(record.pointExpirationTime, 'yearToSecond') }
          </div>
          <div className='marginSide1 widthMin15' >
            { words[record.status][state.language] }
          </div>
          { buttons }
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.purchaseNo[state.language] }
            </div>
            <div className='flexRow alignItemsCenter' >
              <div>
                { 'No. ' + record.purchaseNo }
              </div>
              { buttons }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.amountFree[state.language] }
            </div>
            <div className='' >
              { record.amountFree }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.amountToBuy[state.language] }
            </div>
            <div className='' >
              { record.amountToBuy }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.expirationTime[state.language] }
            </div>
            <div className='' >
              { localTime(record.pointExpirationTime, 'yearToSecond') }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.status[state.language] }
            </div>
            <div className='' >
              { words[record.status][state.language] }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// POINT RECORD DETAIL
function PointRecordDetail(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const record = state.popup[props.popupLayer].body;

  // useEffect( () => {
  //   // state.purchaseに値を格納する。 ←　これやんなくてもいいかも。むしろやらないほうがいいかも。
  //   const purchase = {
  //     purchaseNo: record.purchaseNo,
  //     addressMain: record.addressMain,
  //     addressPayFrom: record.addressPayFrom,
  //     amountToBuy: record.amountToBuy,
  //     signatureByAddressMain: record.signatureByAddressMain,
  //     signatureByAddressPayFrom: record.signatureByAddressPayFrom,
  //     status: record.status,
  //   };

  //   dispatch({ type: 'setState', key: 'purchasePoint', value: purchase });
  // }, []);

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div>
          <ResumePurchaseSigning popupLayer={props.popupLayer} />
        </div>
        <ResumePurchase record={record} popupLayer={props.popupLayer} />
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressMain[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressMain}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.purchaseNo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.purchaseNo}
          </div>
        </div>
        <div className='flexRow boxDetail justifyContentSpaceBetween'>
          <div className='flexColumn '>
            <div>
              {words.addressPayFrom[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressPayFrom}
            </div>
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.unitPriceMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.priceMona + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.amountToBuy[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.amountToBuy + ' point'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            { words.amountFree[state.language] }
          </div>
          <div className='paddingLeft1'>
            { record.amountFree + ' point' }
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.totalPriceMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.priceMonaTotalWatanabe / 100000000) + 'MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.status[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[record.status][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.txidOfSendingMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.receiveMonaTxid}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.applicationTimeOfPurchase[state.language]}
          </div>
          <div className='paddingLeft1'>
            {localTime(record.serverTimeOfAddressMain, 'yearToSecond')}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.purchaseTime[state.language]}
          </div>
          <div className='paddingLeft1'>
            {localTime(record.receiveMonaConfirmationTime, 'yearToSecond')}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.expirationTime[state.language]}
          </div>
          <div className='paddingLeft1'>
            {localTime(record.pointExpirationTime, 'yearToSecond')}
          </div>
        </div>
        {/*
          record.status === 'waitingForSignature' || record.status === 'expiredWithoutSecondSignature' ?
          <div className='flexColumn boxDetail'>
            <div>
              {words.deadlineOfTheSecondSignature[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain + state.config.clientParameters.purchaseSecondSignatureExpirationTime)}
            </div>
          </div>
          : null
        */}
        {/*
          record.status === 'waitingForMona' || record.status === 'expired' ?
          <div className='flexColumn boxDetail'>
            <div>
              {words.deadlineOfSendingMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressPayFrom + state.config.clientParameters.purchaseExpirationTime)}
            </div>
          </div>
          : null
        */}
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div>
          <ResumePurchaseSigning popupLayer={props.popupLayer} />
        </div>
        <ResumePurchase record={record} popupLayer={props.popupLayer} />
        {/* detail */}
        <div className='flexColumn alignItemsCenter'>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressMain[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressMain}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.purchaseNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.purchaseNo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayFrom[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayFrom}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.unitPriceMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.priceMona + ' MONA'}
            </div>
          </div>
          {/*
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitorProceedsNetMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.proceedsNetMona / 100000000) + 'MONA'}
            </div>
          </div>
          */}
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.amountToBuy[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountToBuy}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              { words.amountFree[state.language] }
            </div>
            <div className='paddingLeft1'>
              { record.amountFree }
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.totalPriceMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.priceMonaTotalWatanabe / 100000000) + 'MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.status[state.language]}
            </div>
            <div className='paddingLeft1'>
              {words[record.status][state.language]}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.txidOfSendingMona[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.receiveMonaTxid}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.applicationTimeOfPurchase[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain, 'yearToSecond')}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.purchaseTime[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.receiveMonaConfirmationTime, 'yearToSecond')}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.expirationTime[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.pointExpirationTime, 'yearToSecond')}
            </div>
          </div>
          {/*
            record.status === 'waitingForSignature' || record.status === 'expiredWithoutSecondSignature' ?
            <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
              <div className='width96PC '>
                {words.deadlineOfTheSecondSignature[state.language]}
              </div>
              <div className='paddingLeft1'>
                {localTime(record.serverTimeOfAddressMain + state.config.clientParameters.purchaseSecondSignatureExpirationTime)}
              </div>
            </div>
            : null
          */}
          {/*
            record.status === 'waitingForMona' || record.status === 'expired' ?
            <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
              <div className='width96PC '>
                {words.deadlineOfSendingMona[state.language]}
              </div>
              <div className='paddingLeft1'>
                {localTime(record.serverTimeOfAddressPayFrom + state.config.clientParameters.purchaseExpirationTime)}
              </div>
            </div>
            : null
          */}
        </div>
      </div>
    </div>
  );
}

// RESUME PURCHASE
function ResumePurchase(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const keyPairsInPoolAll = useGlobalStateSelector( ({ state }) => state.keyPairs );
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const record = props.record;
  const popupLayer = props.popupLayer;
  let sendMonaButton;

  if (record.status === 'waitingForMona' && record.sendMonaTxidFromClient === undefined) {
    sendMonaButton =
      <button className='button2 borderRadius2 riseOut2' tabindex='0'
        onClick={ async () => {
          let result;
          let txid;

          // // Mpurseのアドレスが合ってるかチェック

          // result = await window.mpurse.getAddress()
          // .then( (result) => {
          //   const addressActual = result;
          //   devLog('address', record.addressPayFrom, addressActual);

          //   if (addressActual !== record.addressPayFrom) {
          //     dispatch({ type: 'setNotification', key: 'notification', value: words.theRemittanceSourceAddressAndTheAddressInYourWalletAreDifferent[state.language] });
          //     return 'rejected';
          //   }
          //   else {
          //     return 'fulfilled';
          //   }
          // })
          // .catch( (error) => {
          //   dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
          //   return 'rejected';
          // });

          // if (result === 'rejected') {
          //   return { status: 'rejected' };
          // }

          // MONA送金

          dispatch({ type: 'setState', key: 'accessing', value: true });

          // モナ量計算

          const amountToBuyDecimal = new decimal(record.amountToBuy);
          const priceMonaDecimal = new decimal(record.priceMona);
          const amountMona = amountToBuyDecimal.times(priceMonaDecimal).toNumber();

          // 送金！

          try {
            devLog(`amountToBuy ${record.amountToBuy}, priceMona ${record.priceMona}, amountMona ${amountMona}`);

            const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: keyPairsInPoolAll });
            const keyPair = keyPairsInPool[record.addressPayFrom]?.keyPair;

            result = await sendMonaSequence(
              state, dispatch, keyPair, record.addressPayFrom, state.configMP.clientParameters.monatokaPointAddress, amountMona,
              {
                provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
                transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
              }
            );
          }
          finally {
            dispatch({ type: 'setState', key: 'accessing', value: false });
          }

          if (result.status === 'fulfilled') {
            txid = result.body;
            dispatch({ type: 'setNotification', key: 'notification', value: words.succeededToSendMona[state.language] + "\n" + txid });

            await sendLog({
              action: 'sendMona',
              addressMain: record.addressMain,
              purchaseNo: record.purchaseNo,
              signatureByAddressMainFromClient: record.signatureByAddressMain,
              sendMonaTxidFromClient: txid,
              amountToBuy: record.amountToBuy,
            });
            // ↑ sendMonaのnotifyが完了するまで待ちたいから、awaitは必要！ 

            handleClickGetPointHistory(state, dispatch, 0, null, true);
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
          }
        }}
      >
        {words.sendMona[state.language]}
      </button>;



    // if (state.walletType === 'mpurse') {
    //   sendMonaButton =
    //   <button className='button2 borderRadius2 riseOut2' tabindex='0'
    //     onClick={ async () => {
    //       let result;
    //       let txid;

    //       // Mpurseのアドレスが合ってるかチェック

    //       result = await window.mpurse.getAddress()
    //       .then( (result) => {
    //         const addressActual = result;
    //         devLog('address', record.addressPayFrom, addressActual);

    //         if (addressActual !== record.addressPayFrom) {
    //           dispatch({ type: 'setNotification', key: 'notification', value: words.theRemittanceSourceAddressAndTheAddressInYourWalletAreDifferent[state.language] });
    //           return 'rejected';
    //         }
    //         else {
    //           return 'fulfilled';
    //         }
    //       })
    //       .catch( (error) => {
    //         dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
    //         return 'rejected';
    //       });

    //       if (result === 'rejected') {
    //         return { status: 'rejected' };
    //       }

    //       // MONA送金

    //       dispatch({ type: 'setState', key: 'accessing', value: true });

    //       // モナ量計算

    //       const amountToBuyDecimal = new decimal(record.amountToBuy);
    //       const priceMonaDecimal = new decimal(record.priceMona);
    //       const amountMona = amountToBuyDecimal.times(priceMonaDecimal).toNumber();

    //       // 送金！

    //       try {
    //         devLog(`amountToBuy ${record.amountToBuy}, priceMona ${record.priceMona}, amountMona ${amountMona}`);

    //         result = await sendMonaSequence(
    //           state, dispatch, null, record.addressPayFrom, state.configMP.clientParameters.monatokaPointAddress, amountMona,
    //           {
    //             provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
    //             transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
    //           }
    //         );
    //       }
    //       finally {
    //         dispatch({ type: 'setState', key: 'accessing', value: false });
    //       }

    //       // result = await window.mpurse.sendAsset(
    //       //   record.monatokaPointAddress,
    //       //   'MONA', 
    //       //   amountMona, 
    //       //   'no',
    //       // )
    //       // .then( async result => {
    //       //   devLog('succeeded to send MONA', result);
    //       //   dispatch({ type: 'setNotification', key: 'notification', value: words.succeededToSendMona[state.language] + "\n" + result });

    //       //   await sendLog({
    //       //     action: 'sendMona',
    //       //     addressMain: record.addressMain,
    //       //     purchaseNo: record.purchaseNo,
    //       //     signatureByAddressMainFromClient: record.signatureByAddressMain,
    //       //     sendMonaTxidFromClient: result,
    //       //     amountToBuy: record.amountToBuy,
    //       //   });

    //       //   return { status: 'fulfilled', body: result };
    //       // })
    //       // .catch( error => {
    //       //   devLog('failed to send MONA.', error);
    //       //   dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] });

    //       //   /*
    //       //   sendLog({
    //       //     message: 'fail to send MONA.(window.mpurse.sendAsset())',
    //       //     orderNo: resultSendOrder.body.orderNo,
    //       //     addressMona: state.addressMona,
    //       //     addressPolygon: state.addressPolygon,
    //       //     amountMona: state.amountMona.value,
    //       //     amountJpyc: state.amountJpyc.value,
    //       //     addressMonaFixed: stateFixed.addressMona,
    //       //     addressPolygonFixed: stateFixed.addressPolygon,
    //       //     amountMonaFixed: stateFixed.amountMona.value,
    //       //     amountJpycFixed: stateFixed.amountJpyc.value,
    //       //     clientTime: clientTimeMona,
    //       //     serverTime: resultSendOrder.body.serverTime,
    //       //     walletTime: Date.now(),
    //       //     error: error,
    //       //   });
    //       //   */

    //       //   return { status: 'failToSendMona', body: error };
    //       // });

    //       if (result.status === 'fulfilled') {
    //         txid = result.body;
    //         dispatch({ type: 'setNotification', key: 'notification', value: words.succeededToSendMona[state.language] + "\n" + txid });

    //         await sendLog({
    //           action: 'sendMona',
    //           addressMain: record.addressMain,
    //           purchaseNo: record.purchaseNo,
    //           signatureByAddressMainFromClient: record.signatureByAddressMain,
    //           sendMonaTxidFromClient: txid,
    //           amountToBuy: record.amountToBuy,
    //         });
    //         // ↑ sendMonaのnotifyが完了するまで待ちたいから、awaitは必要！ 

    //         handleClickGetPointHistory(state, dispatch, 0, null, true);
    //         dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
    //       }
    //     }}
    //   >
    //     {words.sendMona[state.language]}
    //   </button>;
    // }
    // else if (state.walletType === 'nfc') {
    //   sendMonaButton =
    //   <button className='button2 flexRow justifyContentCenter alignItemsCenter borderRadius2 riseOut2' tabindex='0'
    //     onClick={ async () => {
    //       dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    //       const callback = async (keyPairs) => {
    //         let result;
    //         let addressActual;
    //         let txid;
    //         const keyPair = keyPairs[0];

    //         // NFCのアドレスが合ってるかチェック

    //         result = getAddressFromKey(state, dispatch, keyPair);

    //         if (result.status === 'fulfilled') {
    //           addressActual = result.address;
    //         }
    //         else {
    //           dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
    //           return result;
    //         }

    //         if (addressActual !== record.addressPayFrom) {
    //           dispatch({ type: 'setNotification', key: 'notification', value: words.theRemittanceSourceAddressAndTheAddressInYourKeyCardAreDifferent[state.language] });
    //           return {
    //             status: 'rejected',
    //             error: 'theAddressFilledAndTheAddressInWalletAreDifferent',
    //           };
    //         }

    //         // MONA送金

    //         dispatch({ type: 'setState', key: 'accessing', value: true });

    //         // モナ量計算

    //         const amountToBuyDecimal = new decimal(record.amountToBuy);
    //         const priceMonaDecimal = new decimal(record.priceMona);
    //         const amountMona = amountToBuyDecimal.times(priceMonaDecimal).toNumber();

    //         try {
    //           devLog(`amountToBuy ${record.amountToBuy}, priceMona ${record.priceMona}, amountMona ${amountMona}`);

    //           result = await sendMonaSequence(
    //             state, dispatch, keyPair, record.addressPayFrom, state.configMP.clientParameters.monatokaPointAddress, amountMona,
    //             {
    //               provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
    //               transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
    //             }
    //           );
    //         }
    //         finally {
    //           dispatch({ type: 'setState', key: 'accessing', value: false });
    //         }

    //         if (result.status === 'fulfilled') {
    //           txid = result.body;
    //         }
    //         else {
    //           return result;
    //         }

    //         dispatch({ type: 'setNotification', key: 'notification', value: words.succeededToSendMona[state.language] + "\n" + txid });

    //         await sendLog({
    //           action: 'sendMona',
    //           addressMain: record.addressMain,
    //           purchaseNo: record.purchaseNo,
    //           signatureByAddressMainFromClient: record.signatureByAddressMain,
    //           sendMonaTxidFromClient: txid,
    //           amountToBuy: record.amountToBuy,
    //         });
    //         // ↑ sendMonaのnotifyが完了するまで待ちたいから、awaitは必要！ 

    //         handleClickGetPointHistory(state, dispatch, 0, null, true);
    //         dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
    //       };

    //       handleClickNfc(state, dispatch, callback);
    //     }}
    //   >
    //     <div>
    //       {words.sendMona[state.language]}
    //     </div>
    //     <div>
    //       <img className='size2x2' src={iconKeyCard} />
    //     </div>
    //   </button>;
    // }
    // else { // qr
    //   sendMonaButton =
    //   <button className='button2 flexRow justifyContentCenter alignItemsCenter borderRadius2 riseOut2' tabindex='0'
    //     onClick={ async () => {
    //       dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    //       const callback = async (keyPairs) => {
    //         let result;
    //         let addressActual;
    //         let txid;
    //         const keyPair = keyPairs[0];

    //         // NFCのアドレスが合ってるかチェック

    //         result = getAddressFromKey(state, dispatch, keyPair);

    //         if (result.status === 'fulfilled') {
    //           addressActual = result.address;
    //         }
    //         else {
    //           dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
    //           return result;
    //         }

    //         if (addressActual !== record.addressPayFrom) {
    //           dispatch({ type: 'setNotification', key: 'notification', value: words.theRemittanceSourceAddressAndTheAddressInYourKeyCardAreDifferent[state.language] });
    //           return {
    //             status: 'rejected',
    //             error: 'theAddressFilledAndTheAddressInWalletAreDifferent',
    //           };
    //         }

    //         // MONA送金

    //         dispatch({ type: 'setState', key: 'accessing', value: true });

    //         // モナ量計算

    //         const amountToBuyDecimal = new decimal(record.amountToBuy);
    //         const priceMonaDecimal = new decimal(record.priceMona);
    //         const amountMona = amountToBuyDecimal.times(priceMonaDecimal).toNumber();

    //         try {
    //           devLog(`amountToBuy ${record.amountToBuy}, priceMona ${record.priceMona}, amountMona ${amountMona}`);

    //           result = await sendMonaSequence(
    //             state, dispatch, keyPair, record.addressPayFrom, state.configMP.clientParameters.monatokaPointAddress, amountMona,
    //             {
    //               provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
    //               transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
    //             }
    //           );
    //         }
    //         finally {
    //           dispatch({ type: 'setState', key: 'accessing', value: false });
    //         }

    //         if (result.status === 'fulfilled') {
    //           txid = result.body;
    //         }
    //         else {
    //           return result;
    //         }

    //         dispatch({ type: 'setNotification', key: 'notification', value: words.succeededToSendMona[state.language] + "\n" + txid });

    //         await sendLog({
    //           action: 'sendMona',
    //           addressMain: record.addressMain,
    //           purchaseNo: record.purchaseNo,
    //           signatureByAddressMainFromClient: record.signatureByAddressMain,
    //           sendMonaTxidFromClient: txid,
    //           amountToBuy: record.amountToBuy,
    //         });
    //         // ↑ sendMonaのnotifyが完了するまで待ちたいから、awaitは必要！ 

    //         handleClickGetPointHistory(state, dispatch, 0, null, true);
    //         dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
    //       };

    //       handleClickScanQr(state, dispatch, callback);
    //     }}
    //   >
    //     <div>
    //       {words.sendMona[state.language]}
    //     </div>
    //     <div>
    //       <img className='size2x2' src={iconQr} />
    //     </div>
    //   </button>;
    // }
  }


  return (
    <div className=''>
      {/* PC */}
      <div className='visibleLargeOrMore flexColumn alignItemsCenter'>
        { sendMonaButton }
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess flexColumn alignItemsCenter">
        { sendMonaButton }
      </div>
    </div>
  );
}

// RESUME PURCHASE SIGNING
function ResumePurchaseSigning(props) {
  const popupLayer = props.popupLayer;
  const state = useGlobalStateSelector(({ state }) => state);
  const keyPairsInPoolAll = useGlobalStateSelector( ({ state }) => state.keyPairs );
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const body = state.popup[popupLayer].body;

  return (
      <div className='flexRow justifyContentCenter'>
        {
          (state.popup[props.popupLayer].body.signatureByAddressPayFrom === undefined && state.popup[props.popupLayer].body.status === 'waitingForSignature') ?
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
              onClick={ async () => {
                const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: keyPairsInPoolAll });
                const keyPair = keyPairsInPool[body.addressPayFrom]?.keyPair;

                const result = await handleClickSignPurchase(state, dispatch, 'addressPayFrom', props.popupLayer, keyPair);

                if (result.status === 'fulfilled') {
                  handleClickGetPointHistory(state, dispatch, 0, null, true);
                }
              }}
            >
              <div>
                {words.signByAddressYouPayFrom[state.language]}
              </div>
              <img className='size2x2' src={iconSign} alt='sign' />
            </button>
          : null
        }
      </div>
  );
}

export { ChargePoint, PointRecordDetail };
